import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DateHelpers } from '@/helpers/date-helpers';
import type { RateShopDataRow, RateShopHeader, RateType } from '../shared/types/rate-shop-types';
import { generateExportFilename } from '../shared/utils/rate-formatters';

interface RateDataExportButtonProps {
  brandCode: string;
  data: RateShopDataRow[];
  headers: RateShopHeader[];
  rateType: RateType;
  variant?: 'outline' | 'default' | 'destructive' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
}

export const RateDataExportButton = ({
  brandCode,
  data,
  headers,
  rateType,
  variant = 'outline',
  size = 'sm',
  className,
}: RateDataExportButtonProps) => {
  const exportToCSV = () => {
    const csvContent = [
      headers.map((header) => header.title).join(','),
      ...data.map((row) =>
        row
          .map((cell) => {
            const displayValue = cell?.displayValue || cell?.value || '';
            return `"${displayValue}"`;
          })
          .join(','),
      ),
    ].join('\n');

    const filename = generateExportFilename({
      brandCode,
      rateType,
      date: DateHelpers.today(),
      filename: '', // Not used in this context
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button onClick={exportToCSV} variant={variant} size={size} className={className}>
      <Download className='mr-2 h-4 w-4' />
      Export CSV
    </Button>
  );
};
